/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { HttpLoaderFactory, appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { headerInterceptor } from './app/interceptor/header.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { importProvidersFrom } from '@angular/core';
import { provideToastr } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AgmCoreModule } from '@agm/core';

// bootstrapApplication(AppComponent, appConfig)
//   .catch((err) => console.error(err));

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    //provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([headerInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          // useFactory: (http: HttpClient) => { return new TranslateHttpLoader(http, '../assets/i18n/', '.json'); },
          deps: [HttpClient],
        },
      })
    ),
    provideToastr({
      // timeOut: 1000,
      // positionClass: 'toast-top-right',
      // preventDuplicates: true,
    }),
    NgxSpinnerModule,
    FullCalendarModule,
    importProvidersFrom(
      AgmCoreModule.forRoot({
        apiKey: 'AIzaSyDsmRCwyjiDzB89HJXZbqT3pHvxXt-rE2M'
      })
    ),
  ],
});
